import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import type { Customer, CustomerAddress, CustomerLoyaltyProgram, CustomerOrder } from "../../../../data/types"
import type { CustomerCredentialFormItem } from "../CustomerForm"
import type { CustomerOrderItem } from "../../../../../api/customerOrders"
import type {
    CustomerAddressUpdateRequestedPayload,
    CustomerLoyaltyProgramCreateRequestedPayload,
    CustomerUpdateRequestedPayload,
} from "../../../../../events/Customer/types"

export const transformCustomerOrdersServerData = (serverData: CustomerOrderItem[]): CustomerOrder[] =>
    serverData.map((data: CustomerOrderItem) => ({
        id: data.order_id,
        orderNumber: data.order_number,
        assignment: "",
        createdTimestamp: data.date,
        total: data.total,
    }))

export const composeCustomer = (formItem: CustomerCredentialFormItem, customer: Customer): Customer => {
    return {
        ...customer,
        firstName: formItem.firstName,
        surname: formItem.surname,
        isCompany: formItem.isCompany,
        companyName: formItem.companyEntityName,
        position: formItem.positionAtCompany,
        dateOfBirth: formItem.birth,
        gender: formItem.gender,
        email: formItem.email,
        phoneNumber: formItem.phoneNumber,
        addresses: formItem.addresses,
        // @ts-expect-error
        name: formItem.isCompany ? formItem.companyEntityName : `${formItem.firstName} ${formItem.surname}`,
    }
}

export const mapCustomerToUpdateRequestedPayload = (customer: Customer): CustomerUpdateRequestedPayload => ({
    customer: {
        id: customer.id,
        firstName: customer.firstName,
        surname: customer.surname,
        companyName: customer.companyName,
        isCompany: customer.isCompany,
        position: customer.position,
        gender: customer.gender,
        dateOfBirth: customer.dateOfBirth,
        emailAddress: customer.email,
        phoneNumber: customer.phoneNumber,
    },
})

export const mapCustomerAddressToUpdateRequestedPayload = (
    address: CustomerAddress
): CustomerAddressUpdateRequestedPayload => ({
    id: address.id,
    address: {
        line1: address.line1,
        line2: address.line2,
        zip: address.zip,
        city: address.city,
        state: address.state,
    },
})

export const mapCustomerLoyaltyToCreateRequestedPayload = (
    customerLoyalty: CustomerLoyaltyProgram
): CustomerLoyaltyProgramCreateRequestedPayload => ({
    id: customerLoyalty.id,
    customerId: customerLoyalty.customer_id,
    loyaltyProgramId: customerLoyalty.loyalty_program_id,
    optInDate: customerLoyalty.opt_in_date,
})

export const getCustomerValuationLabel = (val: Maybe<number>): Maybe<number> => {
    if (val == null) {
        return null
    } else if (val <= 0.1) {
        return 10
    } else if (val <= 0.25) {
        return 25
    } else if (val <= 0.5) {
        return 50
    } else {
        return null
    }
}
